import React from 'react';
import Banner from './Banner';
import About from './About';
import Games from './Games';
import Team from './Team';
import Contact from './Contact';

const Home = () => {
  return (
    <>
      <Banner />
      <About />
      <Games />
      <Team />
      <Contact />
    </>
  );
};

export default Home;